import { render, staticRenderFns } from "./OsTestReportForm.vue?vue&type=template&id=effab938&scoped=true"
import script from "./OsTestReportForm.vue?vue&type=script&lang=ts"
export * from "./OsTestReportForm.vue?vue&type=script&lang=ts"
import style0 from "./OsTestReportForm.vue?vue&type=style&index=0&id=effab938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effab938",
  null
  
)

export default component.exports